import { MessageToasterComponent } from './message-toaster.component';

export default angular
  .module('sfMobile.components.message-toaster', ['sfMobile.services.task'])
  .component('sfMessageToaster', MessageToasterComponent).name;
